import { initializeConnector } from "@web3-react/core";
import { Web3AuthWallet } from "./lib/web3AuthWallet";
import { WALLET_CONNECTORS, AUTH_CONNECTION } from "@web3auth/modal";

export const [googleWallet, hooks] = initializeConnector(
  (actions) =>
    new Web3AuthWallet({
      actions,
      options: {
        connector: WALLET_CONNECTORS.AUTH,
        connection: AUTH_CONNECTION.GOOGLE,
      },
    })
);
